module.exports = __webpack_public_path__ + "stackedgraph.872418dfd573b47096e531a1d8c53ee3.png";